export default {
	SUBMIT_FORM: 'FORMUPLOAD_SUBMIT_FORM',
	SUBMIT_FORM_SUCCESS: 'FORMUPLOAD_SUBMIT_FORM_SUCCESS',
	SUBMIT_FORM_FAILURE: 'FORMUPLOAD_SUBMIT_FORM_FAILURE',
	RESET_SUBMIT_FORM: 'FORMUPLOAD_RESET_SUBMIT_FORM',
};
